/**
 * @generated SignedSource<<e68aa35ad62cacf0dc866536640103fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSubscription_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuctionItemSubscription_item">;
  readonly " $fragmentType": "PdpSharedAuctionSubscription_item";
};
export type PdpSharedAuctionSubscription_item$key = {
  readonly " $data"?: PdpSharedAuctionSubscription_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSubscription_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSubscription_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AuctionItemSubscription_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "eb8df05e8d7e5279037b2553004fb8e7";

export default node;
